﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_noAuth from './tpl/noAuth.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';
import View_Pagination from '../../../lib/views/pagination/pagination';
import * as Entities_Memory_Position from '../../entities/memoryPosition';
import View_DigitalClock from '../../../portal/info/module/digitalClock';

export default Marionette.LayoutView.extend({
    getTemplate: function () {
        return tpl_noAuth({  });
    },
    initialize: function () {
        var self = this;
        this.app = this.options.app;

        this.setHasChanged(false);
    },
    setHasChanged: function (enable) {
        this.hasChanged = enable;
    },
    getHasChanged: function () {
        return this.hasChanged;
    },
    saveHasChanged: function (callback) {
        callback();
    },
    cancelHasChanged: function () {
    },
    modelHasChanged: function () {
    },
    regions: {
    },
    onRender: function () {
    },
    ui: {
    },
    events: {
    },
    onAttach() {
    },
}, Backbone.Radio.Requests);